import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AQADocument } from '../../models/aqa-document.interface';

@Component({
  selector: 'app-aqa-thread',
  standalone: true,
  imports: [],
  templateUrl: './aqa-thread.component.html',
  styleUrl: './aqa-thread.component.scss'
})
export class AqaThreadComponent {
  @Input({ required: true }) emails: AQADocument[] = [];
  @Input() currentEmailId?: string;
  @Output() threadClicked = new EventEmitter<AQADocument>();

  formatDate(dateString?: string): string {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  extractName(email?: string): string {
    if (!email) return 'Unknown';
    const match = email.match(/^([^<]+)</);
    return match ? match[1].trim() : email.split('@')[0];
  }

  click(email: AQADocument) {
    if (this.currentEmailId != email.messageId) {
      this.threadClicked.emit(email);
    }
  }
}
